// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Alert, Typography } from '@mui/material'
import React from 'react'
import type { Location, Match, RouterHistory } from 'react-router-dom'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import Container from '../../common/container/Container'
import Header from '../header/Header'
import { i18n } from '../index'
import css from './products.css'
import SaltyProducts from './SaltyProducts'
import SweetProducts from './SweetProducts'
const TABS = {
  SALTY: 'suolaisen-vitriinin-esillepano',
  SWEET: 'makean-vitriinin-esillepano',
}
type ProductsProps = {
  history: RouterHistory
  location: Location
  match: Match
}

class Products extends React.PureComponent<ProductsProps> {
  getTabs = () => [
    {
      label: i18n.t('saltyProducts.header'),
      value: TABS.SALTY,
    },
    {
      label: i18n.t('sweetProducts.header'),
      value: TABS.SWEET,
    },
  ]
  getActiveTab = () => {
    const parts = this.props.location.pathname.split('/')
    return parts[2] || TABS.SALTY
  }
  onTabClick = (tab) => {
    const parts = this.props.location.pathname.split('/')
    const week = parts.length === 4 ? parts[3] : undefined
    const target = [this.getBasePath(), tab.value]
    this.props.history.push((week ? [...target, week] : target).join('/'))
  }
  getBasePath = () => this.props.location.pathname.split('/').slice(0, 2).join('/')

  render() {
    const { match } = this.props
    return (
      <div className={css.component}>
        <Header
          title={i18n.t('vitrineProducts.header')}
          tabs={this.getTabs()}
          tabActive={this.getActiveTab()}
          onTabClick={this.onTabClick}
        />
        <Container>
          <Typography variant='h6'>{i18n.t('vitrineProducts.header')}</Typography>
          <Alert severity='warning' icon={false} className={css.warning}>
            {i18n.t('vitrineProducts.warning')}
          </Alert>
          <Switch>
            <Route path={`${match.path}/${TABS.SALTY}/:date`} component={SaltyProducts} />
            <Route path={`${match.path}/${TABS.SALTY}`} component={SaltyProducts} />
            <Route path={`${match.path}/${TABS.SWEET}/:date`} component={SweetProducts} />
            <Route path={`${match.path}/${TABS.SWEET}`} component={SweetProducts} />
            <Redirect to={`${match.path}/${TABS.SALTY}`} />
          </Switch>
        </Container>
      </div>
    )
  }
}

export default withRouter(Products)
